<template>
	<div class="scrolly-game-cont quote-game scroll-page-container">
		<interface-game-intro v-if="gameState == 'intro'"
			class="full-height"
			:name="$t(title)"
			@start-game="changeGameStatus('playing')"
		/>
		<div v-if="gameState == 'playing'" class="scrolly-actual-game">
			<base-button-rounded v-if="!isMobile" class="exit-game-button" icon="e-remove-3" icon-color="var(--color-black-text)" color="var(--color-white)" @button-clicked="this.gameState = 'intro'"/>
			<base-button-rounded v-else class="exit-game-button" icon="e-remove-3" color="transparent" @button-clicked="this.gameState = 'intro'"/>
			<div class="game-header" v-if="!isMobile">
				<span>{{$t('generic_gioco').toUpperCase()}}</span>
			</div>
			<h2 class="capitalize-first">{{$t(title)}}</h2>
			<component
				:is="gameComponent"
				@exit="() => changeGameStatus('intro')"
				:game-contents="gameContents"

				:description="description"
				:title="title"
			/>
		</div>
	</div>
</template>

<script type="text/javascript">
	
import InterfaceGameIntro from '@components/InterfaceGameIntro.vue';
import InterfaceQuoteGame from '@components/InterfaceQuoteGame.vue';
import InterfaceArtifactInfo from '@components/InterfaceArtifactInfo.vue';
import utils from '@js/utils.js';
import { mapGetters } from 'vuex';

export default {
	name: 'ViewGame',
	components: {
		InterfaceGameIntro,
		InterfaceArtifactInfo
	},
	props: {
		gameContents: [Array, Object],
		title: String,
		description: String,
		gameComponent: [Object, String],
	},
	data() {
		return {
			gameState: 'intro',
			utils,
		}
	},
	computed: {
		...mapGetters(['isMobile'])
	},
	watch: {
		gameState(n, o) {
			if(n == 'playing' && o == 'intro') {
				if(this.isMobile) {
					document.body.style.overflow = 'hidden'
					this.$el.classList.add('on-top')
				}else {
					this.$emit('lock')
				}
			}else if(n == 'intro' && o == 'playing') {
				if(this.isMobile) {
					document.body.style.overflow = 'auto'
					this.$el.classList.remove('on-top')
				}else {
					this.$emit('unlock')
				}
			}
		}
	},
	methods: {
		changeGameStatus(status) {
			this.gameState = status
		},
		showInfo() {
			this.$el.querySelector('.scrolly-artifact-comic-text').style.opacity = 1;
		},
		hideInfo() {
			this.$el.querySelector('.scrolly-artifact-comic-text').style.opacity = 0;
		},
	}
}


</script>

<style lang="scss">
	
	@import "@css/variables.scss";

	@import '@css/views/ViewScrolly.scss';

	.scrolly-game-cont {
		width: 100%;
		height: 100%;
	}

	.exit-game-button {
		position: absolute;
		right: var(--s4);
		top: var(--s2);

		.svg-icon {
			width: 1.375rem;
			height: 1.375rem;
		}
	}

	.scrolly-actual-game {
		height: 100%;

		display: flex;
		position: relative;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;
		gap: 4rem;

		padding: var(--s2) var(--s4) var(--s4);

		.game-header {
			height: 5rem;
			display: flex;
			align-items: center;
		}

		.game-subtitle {
			margin-top: -3rem;
			margin-bottom: 1rem;
		}

		h2 {
			text-align: center;
		}

		--max-game-width: 60vw;

		@media (max-width: $breakpoint-ml) {
			--max-game-width: 80vw;
		}

		@media (max-width: $breakpoint-sm) {
			--max-game-width: calc(100vw - 2.5rem);

			padding: 0;
			gap: 1rem;

			.game-subtitle {
				margin-top: -1rem;
				margin-bottom: 0.5rem;
			}

			.exit-game-button {
				right: 1rem;
				top: 0;
				width: 2rem;
				height: 2rem;
			}

			h2 {
				font-size: calc(1.5 * var(--base-font-size));
				margin: 0 3.5rem;
			}

			& > :last-child {
				padding-bottom: 6rem;
			}
		}
	}

	@media (max-width: $breakpoint-mll) {

		// .scrolly-game-cont.more-responsive {
		// 	--base-font-size: 0.8rem;
		// }
		.scrolly-game-cont.more-responsive .scrolly-actual-game {
			gap: 1rem;
		}

		.scrolly-game-cont.more-responsive .game-header {
			height: fit-content;
		}
	}


	// .scrolly-actual-game .scrolly-artifact-container {
	// 	position: absolute;
	// 	left: calc(var(--s2));
	// 	top: calc(var(--total-bar-height) + var(--s2));
	// }

	.game-info-button {
		position: relative;
		bottom: unset;
	}

	.game-info-button .scrolly-artifact-button {
		opacity: 1;
	}

	.game-info-button .scrolly-artifact-comic-text {
		opacity: 0;
		transition-property: opacity;
		transition-duration: .5s;
		width: fit-content;
		overflow: unset;
		height: fit-content;
		padding: var(--s0) var(--s1);
	}

	.game-info-button .scrolly-artifact-comic-text-content {
		width: 20rem;
		white-space: normal;
	}

	@media (max-width: $breakpoint-sm) {
		.scrolly-game-cont.on-top {
			background-color: inherit;
			position: fixed;
			z-index: 5;
			top: 0;
		}

		.scrolly-game-cont {
			display: flex;
 			padding: var(--menu-size) 0 0;
			align-items: center;
			justify-content: center;
			height: calc(100vh - var(--menu-size));
			overflow-y: scroll;
			margin-top: var(--menu-size);
		}
	}

</style>
